class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.querySelector('[data-cart-drawer]');
    this.activeClass = 'cart-drawer-is-open';
    this.cartIconBubble = document.querySelector('cart-icon-bubble');

    this.closeButtons = this.querySelectorAll('[data-cart-button-close]');
    this.closeButtons.forEach((btn) => btn.addEventListener('click', this.close.bind(this)));

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    // Render cart on load
    this.renderCartOnLoad();
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.renderCartOnLoad();
      }
    });

    // Render cart content on Rebuy add
    document.addEventListener('rebuy.add', (event) => {
      if (document.body.classList.contains('template-cart')) return;
      this.renderCartOnLoad();
    });
  }

  open() {
    document.body.classList.add(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', true);

    this.drawer.focus();
    trapFocus(this.drawer);
    document.body.addEventListener('click', this.onBodyClick);

    showModal(this.drawer);
  }

  close() {
    document.body.classList.remove(this.activeClass);
    this.cartIconBubble.toggleButton.setAttribute('aria-expanded', false);

    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus();

    hideModal(this.drawer);
  }

  renderContents(parsedState,loyaltyPointsBalance = 'undefined') {
    this.getSectionsToRender().forEach((section) => {
      document.querySelector(section.selector).innerHTML =
        this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );

        // render the user loyalty points in the cart drawer again (they are initially loaded, but they are gone once the sections are re-rendered)
        section.id === 'cart-drawer' && loyaltyPointsBalance !== 'undefined' ? this.querySelector('[data-custom-point-balance-ui]').innerHTML = loyaltyPointsBalance : '';

    });

    // Re-bind the close drawer buttons
    this.querySelectorAll('[data-cart-button-close]').forEach((btn) => btn.addEventListener('click', this.close.bind(this)));
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '[data-cart-drawer]',
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.drawer && !target.closest('cart-drawer')) {
      this.close();
    }
  }

  /**
   * renderCartOnLoad
   */
  renderCartOnLoad () {
    fetch(`${window.location.pathname}?sections=${this.getSectionsToRender().map((section) => section.id).join(',')}`, {cache: "no-cache"})
    .then(response => response.json())
    .then((responseJson) => {

      const parsedState = {
        sections: responseJson
      };

      this.renderContents(parsedState);
    });
  }
}

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}
